// eslint-disable-next-line import/prefer-default-export
export enum ContractHistoryType {
  BILLING_DISABLED = 'BILLING_DISABLED',
  DISCOUNT_UPDATED = 'DISCOUNT_UPDATED',
  DISCOUNT_ASSISTED_PURCHASE = 'DISCOUNT_ASSISTED_PURCHASE',
  FEE_UPDATED = 'FEE_UPDATED',
  RULE_PAUSED = 'RULE_PAUSED',
  FIELD_UPDATED = 'FIELD_UPDATED',
  BILLING_ENABLED = 'BILLING_ENABLED',
  RULE_RESTARTED = 'RULE_RESTARTED',
  CANCELED = 'CANCELED',
  READJUSTMENT = 'READJUSTMENT',
  MANAGEMENT_CALCULATION = 'MANAGEMENT_CALCULATION',
  REOPEN = 'REOPEN',
  PUSH_ORDER_UPDATE = 'PUSH_ORDER_UPDATE',
  INSTANCE_REGISTERED = 'INSTANCE_REGISTERED',
  INSTANCE_DELETED = 'INSTANCE_DELETED',
  INSTANCE_INACTIVATED = 'INSTANCE_INACTIVATED',
  INSTANCE_ACTIVATED = 'INSTANCE_ACTIVATED',
  INSTANCE_DATE_CHANGED = 'INSTANCE_DATE_CHANGED',
  PREVIEW_SWITCHED = 'PREVIEW_SWITCHED',
  EXPIRATION_REQUEST_CANCELED = 'EXPIRATION_REQUEST_CANCELED',
  CALCULATION_RULE_APPLY_FAILED = 'CALCULATION_RULE_APPLY_FAILED',
}
